/** @jsxImportSource @emotion/react */
import { styles } from './JobsPagination.styles';

export default function JobsPagination({
  pagination,
  setPagination,
}: {
  pagination: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  };
  setPagination: any;
}) {
  return (
    <div css={styles.wrapper}>
      <button
        disabled={pagination.page <= 1}
        onClick={() => setPagination((p: any) => ({ ...p, page: p.page - 1 }))}
      >
        Prev
      </button>

      <span>
        {pagination.page} / {pagination.pageCount}
      </span>

      <button
        disabled={pagination.page >= pagination.pageCount}
        onClick={() => setPagination((p: any) => ({ ...p, page: p.page + 1 }))}
      >
        Next
      </button>
    </div>
  );
}
